<template>
  <div>
    <table class="mx-auto px-2">
      <tr>
        <th></th>
        <th v-for="column in columns" :key="column">
          <mrx-translation class="table-header" :token="colToken(column)"></mrx-translation>
        </th>
      </tr>
      <tr v-for="(tableRow, index) in tableMap" :key="rows[index]">
        <td>
          <mrx-translation class="table-header" :token="rowToken(rows[index])"></mrx-translation>
        </td>
        <td v-for="(dataCell, index) in tableRow" :key="columns[index]">
          <v-text-field
            class="pt-0 px-4"
            :rules="[validateInput]"
            v-model="dataCell.value"
            autocomplete="off"
            @input="update"
          ></v-text-field>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
  import languageLogic from '@/mixins/languageLogic'
  export default {
    mixins: [languageLogic],
    name: 'tableinput',
    model: {
      prop: 'items',
      event: 'click'
    },
    data() {
      return {
        // rows and columns are hardcoded here
        // right now, the hl enrollment_data panel is the only one that uses this input type
        // if we have more table-type panels, these can be loaded from the panel options
        rows: [
          'kindergarten',
          'special',
          'first',
          'second',
          'third',
          'fourth',
          'fifth',
          'sixth',
          'seventh',
          'eighth',
          'ninth',
          'tenth',
          'eleventh',
          'twelfth',
        ],
        columns: [
          'male',
          'female',
        ],
        tableMap: []
      }
    },
    props: {
      'options': Object,
      'items': Array,
      'panelName': String
    },
    methods: {
      colToken(column) {
        return `responses.${this.panelName}.column.${column}.title`
      },
      rowToken(row) {
        return `responses.${this.panelName}.row.${row}.title`
      },
      validateInput(userInput) {
        // error message is hardcoded
        // should be changed if this input is used for another panel
        return this.valid(userInput) || "Must be between 0-1000"
      },
      valid(userInput) {
        // validation is hardcoded
        // should be changed if this input is used for another panel
        const numberValidationRegex = /^([1-9][0-9]{0,2}|1000|0)$/
        return numberValidationRegex.test(userInput)
      },
      setResponseValue() {
        this.items[0].value = this.tableMap
        this.items[0].selected = true
        this.$emit('selectEvent')
      },
      fillInitialTableMap() {
        // sets the initial table map based on the rows and columns provided
        const values = []
        this.rows.forEach(row => {
          const rowValues = []
          this.columns.forEach(column => {
            rowValues.push({
              name: this.generateDataName(row, column),
              // initial value is hardcoded
              // should be changed if this input is used for another panel
              value: 0
            })
          })
          values.push(rowValues)
        })
        this.tableMap = values
      },
      generateDataName(row, col) {
        return `${col}_${row}`
      },
      update() {
        this.items[0].selected = false
        if (this.allResponsesValid) {
          this.items[0].selected = true
          this.items[0].value = this.tableMap
        }
      },
    },
    computed: {
      allResponsesValid() {
        if (this.tableMap.length === 0) return false
        for (let row of this.tableMap) {
          for (let col of row) {
            if (!this.valid(col.value)) {
              return false
            }
          }
        }
        return true
      }
    },
    mounted() {
      // The initial response value is a string: `data`, which comes from the config database
      // A check for array can be used as a proxy for whether the table map has been loaded yet
      // this is tenuous but works for this instance. In the future we may want a different check
      const hasSavedResponse = Array.isArray(this.items[0].value)
      if (hasSavedResponse) {
        this.tableMap = this.items[0].value
      }
      else {
        // The first time the panel mounts, we will fill the tableMap based on rows/columns
        this.fillInitialTableMap()
      }
    }
  }
</script>

<style scoped>
  .table-header {
    color: var(--primary-blue);
    font-size: 1.2em;
  }
</style>